import { Component, OnInit, Input } from '@angular/core';
import { BpgCommonService } from '../services/bpg-common.service';
import { DataService } from "../../bpg-common/services/data.services";
import { NavigationMenuService } from './navigation-menu.service';
import { Router } from '@angular/router';
import { BpgAdminServices } from 'src/app/bpg-admin/bpg-admin-services';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.css']
})

export class NavigationMenuComponent implements OnInit {
  @Input() showPopUp: any;
  myBpgsData: any;
  login_data: any;
  myBpgList: any;
  links: any;
  landingData: any;
  siteData: any;
  siteList: any;
  siteId: any;
  adminId: any;
  userRoleDetails: any;
  selectedSiteId: any;
  siteName: string;
  isClassVisible: boolean;
  selectedBpgList: any;
  userSiteId = localStorage.getItem('userSiteId');
  isSiteOrBpgCreated: boolean;
  userType: string;
  corporateType: string;
  leadAdminId: any;
  alertSuccess: boolean = false;
  email: any;
  naacAffinityList: any = [];
  publishedNaacList: any = [];
  loginData: any;
  userData: string;
  userIdDto: any;
  userEmail: any;
  userWorkDayID: any;
  isbpgAdmin: boolean = false;
  isNaacAdmin: boolean = false;
  chapterRoute: string = "/chapter-services";
  configureGallery: string = "Configure Gallery";
  configureGalleryRoute: string = "/configure-gallery";
  chapterResources: string = "Chapter Resources";
  chapterResourcesRoute: string = "/document-repository";
  chapterAnnouncement: string = "Chapter Announcement";
  chapterAnnouncementRoute: string = "/chapter-announcements";
  pushNotification: string = "Push Notification";
  pushNotificationRoute: string = "/push-notification";
  membershipReport: string = "Succession Planning";
  membershipReportRoute: string = "/succession-planning";
  emailManagement: string = 'Email Management';
  emailManagementRoute: string = '/email-management'
  groupSignUp = "Membership Group Sign Up";
  groupSignUpRoute = "/membership-group-sign-up";
  isbpgLeadAdmin = false;
  eventPopUpOpened: boolean;
  isSiteAffected: boolean = false;
  siteUpdated: boolean = false;
  oldSiteLocation: string = '';
  newSiteLocation: string = '';
  membershipsList: any = [];  
  leadershipsList: any = [];
  sitePreference: string = '';
  constructor(private bpgCommonService: BpgCommonService,
    private router: Router,
    private adminService: BpgAdminServices,
    private readonly selfService: SelfService,
    private data: DataService,
    private spinner: Ng4LoadingSpinnerService) {
    this.bpgCommonService.isSiteOrBpgCreated.subscribe(value => {
      this.isSiteOrBpgCreated = value;
      if (this.isSiteOrBpgCreated == true) {
        this.prepareMainMenu();
      }
    })
  }

  ngOnInit() {
    //console.log(this.showPopUp)
    //this.data.userRoleData.subscribe(userRoleDetails => this.userRoleDetails = userRoleDetails);
    //this.selectedSiteIdForNav = localStorage.getItem('userSiteId');




    //   if(this.loginDetails != null)
    //   {
    //   if(this.loginDetails.emailId=='' || this.loginDetails.emailId==null)
    //   {
    //   this.showPopUp=true;
    //   if(localStorage.getItem('emailUpdated') == 'true')
    //   this.showPopUp=false;
    //   } 
    // }
    // this.getnaacData();
    this.data.isEventPopupOpened.subscribe(data => this.eventPopUpOpened = data)
    this.data.selectedBpgList.subscribe(selectedBpgList => this.selectedBpgList = selectedBpgList)
    this.userEmail = sessionStorage.getItem('userEmail') ? sessionStorage.getItem('userEmail') : '';
    let truncatedUpn = sessionStorage.getItem('userEmail')
    truncatedUpn = truncatedUpn.substring(0, truncatedUpn.indexOf('@'))
    let loginDto = {
      'firstName': sessionStorage.getItem('userFirstName') ? sessionStorage.getItem('userFirstName') : '',
      'lastName': sessionStorage.getItem('userLastName') ? sessionStorage.getItem('userLastName') : '',
      'email': sessionStorage.getItem('userEmail') ? sessionStorage.getItem('userEmail') : '',
      'createdBy': sessionStorage.getItem('userFirstName') && sessionStorage.getItem('userLastName') ? sessionStorage.getItem('userFirstName') + ' ' + sessionStorage.getItem('userLastName') : '',
      'modifiedBy': sessionStorage.getItem('userFirstName') && sessionStorage.getItem('userLastName') ? sessionStorage.getItem('userFirstName') + ' ' + sessionStorage.getItem('userLastName') : '',
      'accessToken': sessionStorage.getItem('access_token') ? sessionStorage.getItem('access_token') : ''
    } 
    let workdayId = sessionStorage.getItem('workdayId')
    this.bpgCommonService.loginMonitor(loginDto).subscribe(data => {
      console.log('login monitor :::::::: ', JSON.stringify(data));
      if(data)
      {
        let emailDto = {
          "userEmailId": this.userEmail,
          "workdayId": workdayId
    
        }
        this.bpgCommonService.isTokenPresent.subscribe(tokenRes => {
          // const isToken = sessionStorage.getItem("id_token") == null || sessionStorage.getItem("XAapiKey") == null? false : true;
          if (tokenRes) {
            this.bpgCommonService.userDetailsByEmailId(emailDto).subscribe(data => {
              this.loginData = data;
              console.log("###Header component###")
              console.log(JSON.stringify(this.loginData));
              if (data.emailId == null) {
                this.bpgCommonService.loginError.next(false);
                localStorage.clear();
                sessionStorage.clear();
                this.router.navigate(['/login-error']);
              } else {
    
                localStorage.setItem('loginData', JSON.stringify(this.loginData));
                this.userData = JSON.parse(localStorage.getItem('loginData'));
                this.userIdDto = { "userId": this.userData['userId'] };
                this.bpgCommonService.setloggedInHeader();
                this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {
    
                  this.userRoleDetails = data;
                  localStorage.setItem('isMultiChapterAdmin',this.loginData['isMultiChapterAdmin']);
                  localStorage.setItem('userSiteId', this.loginData['site']['siteId']);
                  //localStorage.setItem('adminId', this.userRoleDetails['adminId']);
                  localStorage.setItem('selectedSiteId', this.loginData['site']['siteId']);
                  localStorage.setItem('leadAdminId', this.userRoleDetails['leadAdminId']);
                  sessionStorage.setItem('emailAddressForMembership',this.loginData['emailId']);
                  if (this.userRoleDetails['adminId'].length == 1) {
                    localStorage.setItem('adminId', this.userRoleDetails['adminId'][0].toString())
                  }
                  if (this.userRoleDetails['adminId'].length > 1) {
                    const adminId = this.userRoleDetails['adminId'];
                    localStorage.setItem('adminId', adminId.toString())
                    for (var i = 0; i < this.userRoleDetails['adminId'].length; i++) {
                      if (this.userRoleDetails['adminId'][i] == '2') {
                        this.isbpgLeadAdmin = true;
                        localStorage.setItem('isbpgLeadAdmin', 'true');
                        console.log(this.isbpgLeadAdmin)
                      }
                      if (this.userRoleDetails['adminId'][i] == '3') {
                        this.isbpgAdmin = true;
                        localStorage.setItem('isbpgAdmin', 'true');
                      }
                      if (this.userRoleDetails['adminId'][i] == '4') {
                        this.isNaacAdmin = true;
                        localStorage.setItem('isNaacAdmin', 'true');
                      }
    
    
                    }
    
                  }
    
                  this.login_data = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
                  if (this.login_data != undefined) {
                    if (this.login_data.site == undefined || this.login_data.site == null || this.login_data.site == '') {
                      this.router.navigate(['/login-error'])
                    }
                    else {
                      if (this.login_data.emailId == "" || this.login_data.emailId == null) {
                        this.showPopUp = true;
                      }
                      if (localStorage.getItem('emailUpdated') == 'true') {
                        this.showPopUp = false;
                      }
    
                      this.userType = (this.login_data.userType) ? this.login_data.userType.trim() : '';
                      this.corporateType = (this.login_data.corporatePartnerType !== null && this.login_data.corporatePartnerType !== undefined) ? this.login_data.corporatePartnerType.trim() : '';
    
    
                    }
                    this.bpgCommonService.checkSiteAffected(this.userData['userId']).subscribe(data => {
                    if (data && data.isSiteAffected) {
                      this.isSiteAffected = true;
                      this.data.setBanner(false);
                      this.oldSiteLocation = data.oldSiteName;
                      this.newSiteLocation = data.newSiteName;
                      this.membershipsList = data.membershipsList?data.membershipsList:[]
                      this.leadershipsList = data.leadershipList?data.leadershipList:[]
                    }
                    else {
                      this.isSiteAffected = false;
                      this.data.setBanner(true);
    
                      // this.showSiteSelectionPopUp = false;
    
                    }}
                    )
                    this.adminId = localStorage.getItem('adminId');
                    this.leadAdminId = localStorage.getItem('leadAdminId');
    
                    this.prepareMainMenu();
                    if (localStorage.getItem('loginData') != null) {
                      if (sessionStorage.getItem('firstLogin') == 'true') {
                        sessionStorage.setItem('firstLogin', 'false');
                        if (sessionStorage.getItem('landingPage') == 'eventDetails') {
                          let id = localStorage.getItem('eventId');
                          console.log("eventId", id)
                          this.router.navigate(['/event-view-details', id]);
                        }
                        else if (sessionStorage.getItem('landingPage') == 'takeSurvey') {
                          let id = localStorage.getItem('surveyId');
                          this.router.navigate(['/take-survey', id]);
                        }
                        else if (sessionStorage.getItem('landingPage') == 'membershipSite') {
                          this.router.navigate(['/membership/site'])
                        }
                        else {
                          this.router.navigate(['/di-home']);
    
                        }
    
                      }
                    }
                  }
    
                  //this.pageOnLoadFunction();
                })
              }
    
            })
          }
        })
      }
      else
      {
        this.router.navigate(['/log-out'])
      }
    })

    

  }


  updateSite() {
    this.spinner.show()

    const siteData = {
      'siteFlag': this.sitePreference,
      'userId': this.loginData.userId

    }

    if (this.sitePreference == 'new') {
      this.siteUpdated = true;  
      window.setTimeout(() => {
        this.isSiteAffected = false;
      }, 500);
}
this.spinner.show()

    this.selfService.updateNewSite(siteData).subscribe(data => {
      

      if (data !== null && data !== undefined) {
        this.data.setBanner(true);

        if (this.sitePreference == 'new') {
                window.location.reload();
             } 

        if (this.sitePreference == 'old') {
    
          this.siteUpdated = true;
          window.setTimeout(() => {
            this.spinner.hide()  ;

            this.siteUpdated = false;
            this.isSiteAffected = false;

          },1500);

          // this.showSiteSelectionPopUp = false;
        }

      }
    })


  }

  prepareMainMenu() {
    //home page menu
    // localStorage.setItem('selectedSiteId', this.userSiteId);
    //  this.userSiteId = localStorage.getItem('selectedSiteId');
    let menuData = [
      { label: "Home", route: ["/di-home"], id: 10 },
      { label: "My Site", route: ["/site-home"], id: 80 }
    ];
    this.prepareMembershipMenu(menuData);
  }
  prepareMembershipMenu(menuData) {
    // Changes to enable the Membership Application Menu for All the users
    // && this.login_data.site.locationCode != "DFLT"
    if (this.userType.toUpperCase() == "EMPLOYEE") {
      menuData.push({ label: "Membership Application", route: "/user-membership", id: 30 });
    } else if (this.userType.toUpperCase() == "CORPORATE PARTNER") {
      if (this.corporateType.toUpperCase() == "CONTINGENT" || this.corporateType.toUpperCase() == "TECHNICAL CONTRACTOR") {
        menuData.push({ label: "Membership Application", route: "/user-membership", id: 30 });
      }
    }

    //for expense menu
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
      menuData.push({ label: "Budget", route: "/expense-list", id: 60 });
    }
    this.prepareMenuPendingEvents(menuData);
  }

  prepareMenuPendingEvents(menuData) {
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isNaacAdmin || this.isbpgAdmin || this.isbpgLeadAdmin) {
      menuData.push({ label: "Events", route: "/events", id: 70 });
    }
    this.prepareMenuEventCalender(menuData);
  }
  prepareMenuEventCalender(menuData) {
    menuData.push({ label: "Events Calendar", route: "/events-calendar", id: 50 });
    this.prepareMenuAdmin(menuData);
  }
  prepareMenuAdmin(menuData) {
    if (this.adminId === '1') {
      menuData.push({
        label: "Admin Management", id: 56, children: [
          { label: "Super Admin", route: "/admin", id: 57 },
          { label: "BPG Admin", route: "/chapter-admin", id: 57 },
          { label: "NAAC Admin", route: "/naac-admin", id: 57 },
        ]
      });
    }
    if (this.adminId === '2' || this.leadAdminId === 'true' || this.isbpgLeadAdmin) {
      menuData.push({
        label: "Admin Management", id: 56, children: [
          { label: "BPG Admin", route: "/chapter-admin", id: 57 }
        ]
      });
    }

    this.prepareMenuBudget(menuData);

  }
  prepareMenuBudget(menuData) {
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
      if(localStorage.getItem("isMultiChapterAdmin")==='true'){
        menuData.push({ label: "Hoshin", route: "/hoshin-home", id: 100 });
      }else{
        menuData.push({ label: "Hoshin", route: "/hoshin", id: 100 });
      }
      
    }
    this.prepareMenuReport(menuData);

  }
  prepareMenuReport(menuData) {
    //Commented admin 2 and admin 3 for membership release
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
      // if (this.adminId == 1) {
      menuData.push({ label: "Reports", reportid: 1 })
    }
    this.prepareBpgMenu(menuData);
  }

  prepareBpgMenu(menuData) {
    this.myBpgsData =
    {
      "filter": {
        // "siteId": this.userSiteId,
        "userId": this.login_data['userId']
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getBPGsList(this.myBpgsData).subscribe(data => {
      if (data) {
        this.myBpgList = data;

        this.data.selectedNavigationBpgs(this.myBpgList);

        if (this.myBpgList.length != 0) {
          menuData.push({ label: " My BPGs", route: "", id: 20, children: [] });
          for (var j = 0; j < menuData.length; j++) {
            if (menuData[j].id == 20) {
              for (var i = 0; i < this.myBpgList.length; i++) {
                menuData[j].children.push({ label: this.myBpgList[i]['siteAndBpgName'], bpgId: this.myBpgList[i]['bpgId'], route: "/chapter-home", id: 20 + i + 1, siteId: this.myBpgList[i]['siteId'] })
              }
            }
          }
        }
        this.prepareSelfServiceMenu(menuData);
      }
    });
  }


  prepareSelfServiceMenu(menuData) {
    if (this.adminId === '1') {
      menuData.push({
        label: "Self Services", route: "/site-home", id: 40, children: [
          // { label: "Areas Of Impact", route: "/area-of-impact-services", id: 41 },
          { label: "BPGs", route: "/bpg-services", id: 42 },
          { label: "Chapters List", route: this.chapterRoute, id: 43 },
          // { label: "Demographics", route: "/demographics-services", id: 44 },
          { label: "Site", route: "/site-services", id: 45 },
          // { label: "Skills", route: "/skills-services", id: 46 },
          { label: "D+I", route: "/d&i-services", id: 49 },
          { label: this.configureGallery, route: this.configureGalleryRoute, id: 99 },
          { label: this.chapterResources, route: this.chapterResourcesRoute, id: 101 },
          { label: this.chapterAnnouncement, route: this.chapterAnnouncementRoute, id: 105 },
          { label: this.pushNotification, route: this.pushNotificationRoute, id: 106 },
          { label: this.membershipReport, route: this.membershipReportRoute, id: 102 },
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },
          { label: "NAAC", route: "/naac", id: 104 },
          { label: this.groupSignUp, route: this.groupSignUpRoute, id:107}
        ]
      });
    }
    else if (this.adminId === '2' || this.adminId === '3' || this.isbpgAdmin || this.isbpgLeadAdmin) {
      menuData.push({
        label: "Self Services", route: "/site-home", id: 47, children: [
          { label: "Chapters List", route: this.chapterRoute, id: 48 },
          { label: this.configureGallery, route: this.configureGalleryRoute, id: 99 },
          { label: this.chapterResources, route: this.chapterResourcesRoute, id: 101 },
          { label: this.chapterAnnouncement, route: this.chapterAnnouncementRoute, id: 105 },
          { label: this.pushNotification, route: this.pushNotificationRoute, id: 106 },
          { label: this.membershipReport, route: this.membershipReportRoute, id: 102 },
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },
          { label: "NAAC", route: "/naac", id: 104 },
          { label: this.groupSignUp, route: this.groupSignUpRoute, id:107}

        ]
      });
    }

    else if (this.adminId !== '1' && this.adminId !== '2' && this.adminId !== '3' && this.adminId !== '4' && !this.isbpgAdmin && !this.isNaacAdmin && !this.isbpgLeadAdmin) {

      menuData.push({
        label: "Self Services", route: "/site-home", id: 47, children: [
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },

        ]
      });
    }
    if (this.adminId == '4') {
      menuData.push({
        label: "Self Services", route: "/site-home", id: 47, children: [
          //       { label: this.emailManagement, route: this.emailManagementRoute, id: 103 } ,
          { label: "NAAC", route: "/naac", id: 104 }
        ]

      });
    }

    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isNaacAdmin || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.prepareNaacMenu(menuData);
    }
    else {
      this.prepareSiteMenu(menuData);
    }
  }

  // prepareMenuDiHome(menuData) {
  //   // if (this.adminId == 1 || this.adminId == 2 || this.adminId == 3) {
  //   menuData.push();
  //   //  }
  //   this.(menuData);
  // }
  prepareNaacMenu(menuData) {

    let LandingPaginationDTO = {
      "filter": {
        "naacFlag": "naacSelfService",
        "adminId": this.adminId,
        "userId": this.login_data.userId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": ""

    }

    this.selfService.getnaacAffinityList(LandingPaginationDTO).subscribe(data => {
      this.naacAffinityList = data;
      console.log(this.naacAffinityList)
      this.publishedNaacList = [];
      for (var i = 0; i < this.naacAffinityList.length; i++) {
        if (this.naacAffinityList[i].naacStatus == 'Publish') {
          this.publishedNaacList.push(this.naacAffinityList[i]);

        }
      }
      if (this.publishedNaacList.length != 0) {
        menuData.push({ label: "NAACs", id1: 0, route: "", children: [] });
        for (var j = 0; j < menuData.length; j++) {
          if (menuData[j].label == "NAACs") {
            for (var i = 0; i < this.publishedNaacList.length; i++) {
              menuData[j].children.push({ label: this.publishedNaacList[i].naacAffinityName, naacId: this.publishedNaacList[i].naacId, naacAffinityId: this.publishedNaacList[i].naacAffinityId, route: "/naac-home", id1: i + 1 })
            }
          }
        }

      }
    })
    this.prepareSiteMenu(menuData)
  }
  childArray: any;
  prepareSiteMenu(menuData) {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    //this.data.selectedSiteIdForSiteMenu(localStorage.getItem('selectedSiteId'));
    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;

      if (this.siteList != null) {
        for (var i = 0; i < this.siteList.length; i++) {
          if (localStorage.getItem('selectedSiteId') == this.siteList[i].siteId) {
            menuData.push({ label: this.siteList[i].siteName, route: "/site-home", id: 60, children: [] });

            for (var i = 0; i < this.siteList.length; i++) {
              menuData[menuData.length - 1].children.push({ label: this.siteList[i].siteName, route: ["/site-home"], id: 60 + i + 1, 'siteUniqueId': this.siteList[i].siteId })

            }
          }
        }
      }
    })
    this.links = menuData;
    console.log(this.links)

  }

  public childClicked(label, siteId) {
    localStorage.setItem('selectedSiteId', siteId);
    this.selectedSiteId = siteId;
    this.data.selectedSiteIdForSiteMenu(siteId);
    this.links.splice(-1);
    this.links.push({ label: label, route: "/site-home", id: 60, children: [] });
    for (var i = 0; i < this.siteList.length; i++) {

      this.links[this.links.length - 1].children.push({ label: this.siteList[i].siteName, route: ["/site-home"], id: 60 + i + 1, 'siteUniqueId': this.siteList[i].siteId })
    }
    this.clicked();
  }

  childLinkClicked(bpgId, siteId) {
    localStorage.setItem('bpgId', bpgId);
    localStorage.setItem('siteId', siteId);
    var chapterDetailsData = {
      'siteId': siteId,
      'bpgId': bpgId,
      'path': 'myBpg'
    }
    this.data.setMyBpgSiteIdAndBpgId(chapterDetailsData);
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  childLinkClickedNaac(naacId, naacName, naacAffinityId) {
    let naacDetails = {
      "naacId": naacId,
      "naacName": naacName,
      "naacAffinityId": naacAffinityId
    }
    localStorage.setItem('selectedNaacId', naacId);
    localStorage.setItem('selectedNaacName', naacName);
    localStorage.setItem('naacAffinityId', naacAffinityId);
    //console.log(naacDetails)
    this.data.selectednaacIdForNaacMenu(naacDetails);

  }
  isSiteClassVisible() {
    this.isClassVisible = true;
  }

  goToReport() {
    window.open("https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/ab2d6f8d-1289-4a56-b325-77b5d7596ecd/ReportSection", "_blank")
  }
  clicked() {
    if (window.innerWidth <= 1200) {
      document.getElementById("collapseBtn").click();
    }
  }
  home() {
    localStorage.setItem('selectedSiteId', this.userSiteId);
    this.userSiteId = localStorage.getItem('selectedSiteId');
    this.data.selectedSiteIdForSiteMenu(this.userSiteId);
    this.ngOnInit();
    this.clicked();
  }
  updateEmail() {
    this.email = document.getElementById("email");
    this.email = this.email.value;

    var landingData = {
      "createdBy": this.login_data.userId,
      "createdDateTime": new Date(),
      "isActive": true,
      "modifiedBy": new Date(),
      "modifiedDateTime": new Date(),
      "userId": this.login_data.userId,
      "emailId": this.email
    }
    this.adminService.updateEmail(landingData).subscribe(data => {
      if (data != null) {
        this.alertSuccess = true;
        this.showPopUp = false;
        localStorage.setItem("emailUpdated", 'true');
      }
    });


  }






}


